/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApi } from './BaseApi';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UniversalTrackerValueApi {
  protected baseApi: BaseApi;
  endPoint: string = '/api/admin/universal-tracker-values';

  constructor(
    public http: HttpClient
  ) {
    this.baseApi = new BaseApi(http);
    this.baseApi.setEndPoint(this.endPoint);
  }

  public findById(id: any): Observable<any> {
    return this.baseApi.findById(id);
  }

  public findByCode(code: any): Observable<any> {
    return this.baseApi.findByCode(code);
  }

  public importOrReplace(row: any): Observable<any> {
    return this.baseApi.post(this.endPoint + '/importAndReplace', {}, row);
  }

  public list(limit?: number, offset: number = 0): Observable<any> {
    return this.baseApi.list(limit, offset);
  }

  public create(_postBody: any): Observable<any> {
    return this.baseApi.create(_postBody);
  }

  public evidence(id: any, _postBody: any): Observable<any> {
    return this.baseApi._unimplemented('addEvidence');
  }

  public verifyAllBySourceCode(universalTrackerId: any, sourceCode: any): Observable<any> {
    const _routeParams: any = {
      sourceCode: sourceCode,
      universalTrackerId: universalTrackerId
    };
    return this._customPatch(this.endPoint + '/verifyAll/universalTrackerId/:universalTrackerId/sourceCode/:sourceCode', _routeParams, {});
  }

  public rejectAllBySourceCode(universalTrackerId: any, sourceCode: any): Observable<any> {
    const _routeParams: any = {
      sourceCode: sourceCode,
      universalTrackerId: universalTrackerId
    };
    return this._customPatch(this.endPoint + '/rejectAll/universalTrackerId/:universalTrackerId/sourceCode/:sourceCode', _routeParams, {});
  }

  public verify(id: any): Observable<any> {
    const _routeParams: any = {
      id: id
    };
    return this._customPatch(this.endPoint + '/:id/verify', _routeParams, {});
  }

  public reject(id: any): Observable<any> {
    const _routeParams: any = {
      id: id
    };
    return this._customPatch(this.endPoint + '/:id/reject', _routeParams, {});
  }

  public update(id: any, value: number, sampleSize: number): Observable<any> {
    const _routeParams: any = {
      id: id
    };
    const _postBody: any = {
      value: value,
      sampleSize: sampleSize
    };
    return this._customPatch(this.endPoint + '/:id/update', _routeParams, _postBody);
  }

  public findBySource(sourceType, sourceCode) {
    const _routeParams: any = {
      sourceType: sourceType,
      sourceCode: sourceCode
    };
    return this.baseApi.get(this.endPoint + '/source/:sourceType/:sourceCode', _routeParams);
  }

  public findByUniversalTrackerId(universalTrackerId) {
    const _routeParams: any = {
      universalTrackerId: universalTrackerId
    };
    return this.baseApi.get(this.endPoint + '/universalTrackerId/:universalTrackerId', _routeParams);
  }

  public findByUniversalTrackerIdAndInitiativeId(universalTrackerId, initiativeId) {
    const _routeParams: any = {
      universalTrackerId: universalTrackerId,
      initiativeId: initiativeId
    };
    return this.baseApi.get(this.endPoint + '/universalTrackerId/:universalTrackerId/initiativeId/:initiativeId', _routeParams);
  }

  public findByInitiativeId(initiativeId) {
    const _routeParams: any = {
      initiativeId: initiativeId
    };
    return this.baseApi.get(this.endPoint + '/initiativeId/:initiativeId', _routeParams);
  }

  protected _customPatch(_url, _routeParams, _postBody): Observable<any> {
    const _absoluteURL = this.baseApi._generateURL(_url, _routeParams);
    const _options = {};
    return this.http.patch(_absoluteURL, _postBody, _options);
  }

  public replace(_postBody: any): Observable<any> {
    return this.baseApi.replace(_postBody)
  }
}
